import React, { useMemo } from "react";
import { ShoppingCart } from "lucide-react";

import { reais } from "../formato";
import Bloco from "./Bloco";
import Contador from "./Contador";
import { produtoExemplo } from "./exemplo";

function Unidade({ ordem, comDesconto, preco }) {
  return (
    <div className={`rounded-lg border px-2.5 py-1.5 text-center min-w-[4.5rem] ${comDesconto ? "border-emerald-500/50 bg-emerald-500/15" : "border-border bg-background"}`}>
      <p className="text-sm font-bold leading-tight tabular-nums">{ordem}</p>
      <p className={`text-[10px] leading-tight ${comDesconto ? "text-emerald-600 dark:text-emerald-400 font-semibold" : "text-muted-foreground"}`}>
        {comDesconto ? "com desconto" : preco ? reais(preco) : "preço normal"}
      </p>
    </div>
  );
}

// Limite por cliente, por produto e por dia (o servidor barra no pedido).
export default function SecaoLimite({ config, produtos, onMudar }) {
  const n = Math.max(1, Number(config.limite_unidades) || 1);
  const exemplo = useMemo(() => produtoExemplo(produtos, config), [produtos, config]);
  const nome = exemplo?.name || "um produto";
  const mostradas = n <= 5 ? Array.from({ length: n }, (_, i) => i + 1) : [1, 2, "…", n];

  return (
    <Bloco icone={ShoppingCart} titulo="Limite de compra com desconto"
      subtitulo="Até quantas unidades de um mesmo produto em oferta o cliente pode comprar com desconto por dia.">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="shrink-0 flex flex-col items-center gap-1">
          <Contador valor={n} min={1} max={20} rotulo="unidades" e2e="limite-unidades" onMudar={(v) => onMudar("limite_unidades", v)} />
          <p className="text-[11px] text-muted-foreground text-center leading-tight">{n === 1 ? "unidade" : "unidades"} com desconto<br />por produto, por dia</p>
        </div>
        <div className="flex-1 rounded-xl bg-muted/50 p-3" data-e2e="exemplo-limite">
          <p className="text-xs text-muted-foreground mb-2">
            Exemplo: o cliente ganhou oferta em <b className="text-foreground">{nome}</b> e colocou {n + 1} no carrinho.
          </p>
          <div className="flex flex-wrap items-center gap-1.5">
            {mostradas.map((i) => (i === "…"
              ? <span key="reticencias" className="px-1 text-muted-foreground">…</span>
              : <Unidade key={i} ordem={`${i}ª`} comDesconto />))}
            <Unidade ordem={`${n + 1}ª`} preco={exemplo?.preco} />
          </div>
          <p className="text-xs mt-2.5 leading-snug">
            {n === 1
              ? <>Só <b>1 unidade</b> sai com desconto. A <b>2ª</b> já sai no preço normal.</>
              : <>As <b>{n} primeiras</b> saem com desconto. A <b>{n + 1}ª</b> em diante sai no preço normal.</>}
          </p>
          <p className="text-[11px] text-muted-foreground mt-1 leading-snug">
            O limite é de cada produto: se ele também ganhou oferta em outro produto, leva até {n} {n === 1 ? "unidade" : "unidades"} dele com desconto também. No dia seguinte, recomeça.
          </p>
        </div>
      </div>
    </Bloco>
  );
}
